import React from "react";

export const Checkmark = ({
  width = 9,
  height = 7,
  fill = "#000000",
}: {
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.79688 6.52999L0.84375 3.44288L1.26562 2.88159L3.65625 4.56546L7.73438 0.496094L8.29688 1.05739L3.79688 6.52999Z"
        fill={fill}
      />
    </svg>
  );
};
